import { render } from "./OrderCircle.vue?vue&type=template&id=08038d2c&scoped=true"
import script from "./OrderCircle.vue?vue&type=script&lang=js"
export * from "./OrderCircle.vue?vue&type=script&lang=js"

import "./OrderCircle.vue?vue&type=style&index=0&id=08038d2c&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08038d2c"]])

export default __exports__